import React from 'react'
import { withUserStore } from '../../contexts/UserStore'
import ProfileContainer from '../Profile/ProfileContainer'

const Profile = ({ userStore }) => {
  return <ProfileContainer userStore={userStore} />
}

export default withUserStore(Profile)
